import React, { useEffect } from 'react';
import ServerCard from '../../components/ServerCard/ServerCard';
import Footer from '../../components/Footer/Footer';
import Banner from '../../components/Banner/Banner';
import ContactForm from '../../components/ContactForm/ContactForm';
import { FromStore } from '../../../helpers/Store';
import { useAppDispatch } from '../../../helpers/UseAppDispatch';
import { ApiGetServersCards } from '../../../stores/api/server/actions';
import { ServerCardData } from '../../../api/dtos/server/ServerCardResponse';
import NavBar from '../../components/NavBar/NavBar';

const Home: React.FC = () => {
    const dispatch = useAppDispatch();
    const servers: ServerCardData[] = FromStore(state => state.apis.servers.serversCards);
    
    useEffect(() => {
        dispatch(ApiGetServersCards());
    }, [dispatch]);

    return (
        <>
            <NavBar />
            <div className='main_content' >
                <Banner />
                <div className='servers_part' >
                    <h2>SERVERS GAMES</h2>
                    <div className='servers_cards'>
                        {servers.map((application, index) => (
                            <ServerCard key={index} game={application.game} percentage={application.percentage} lastUpdate={application.lastUpdate} />
                        ))}
                    </div>
                </div>
                <ContactForm />
                <Footer />
            </div>
        </>
    );
}

export default Home;
